import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.includes.js";
import "core-js/modules/es.string.match.js";
import "core-js/modules/es.string.replace.js";
export var redirectToApp = function redirectToApp() {
  var eventLocation = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "Banner";
  var _a;
  if (window.navigator.userAgent.includes("iPhone")) {
    //firefox on ios can't open the app
    if (!window.navigator.userAgent.match(/firefox|fxios/i)) window.location.replace("wikicasa://");
    setTimeout(() => {
      window.location.replace("https://apps.apple.com/it/app/wikicasa/id1626038379");
    }, 500);
  } else if (window.navigator.userAgent.includes("Android")) {
    var url = "intent://wikicasa.it/#Intent;scheme=https;package=it.wikicasa.wikicasa_app;end";
    window.location.replace(url);
  }
  //@ts-ignore
  window.dataLayer.push({
    //GA4
    "event_name": "open_store",
    "event_location": eventLocation,
    "OS": (_a = window.navigator) === null || _a === void 0 ? void 0 : _a.userAgent
  });
};